var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import DebugService from "./DebugService";
import { environment } from "../config/environment";
class PlacementApiSearchService {
    constructor() { }
    static getInstance() {
        if (!PlacementApiSearchService.instance) {
            PlacementApiSearchService.instance = new PlacementApiSearchService();
        }
        return PlacementApiSearchService.instance;
    }
    /**
     * Gets the API URL dynamically from environment config
     */
    getApiUrl() {
        const url = environment.PLACEMENT_API_URL || "https://localhost:4001/api/placements";
        return url;
    }
    /**
     * Gets the subscription key dynamically from environment config
     */
    getSubscriptionKey() {
        const key = environment.PLACEMENT_API_KEY || "";
        if (!key) {
            DebugService.warn("PlacementApiSearchService: PLACEMENT_API_KEY is empty");
        }
        return key;
    }
    getAuthHeaders(apiToken) {
        return {
            "Ocp-Apim-Subscription-Key": this.getSubscriptionKey(),
            Authorization: `Bearer ${apiToken}`,
        };
    }
    searchPlacementID(apiToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                debugger;
                DebugService.placement("Starting placement search request");
                const queryParams = new URLSearchParams({
                    productCode: data.productCode,
                    searchString: data.searchString,
                }).toString();
                const headers = this.getAuthHeaders(apiToken);
                const apiUrl = `${this.getApiUrl()}?${queryParams}`;
                DebugService.api("GET", apiUrl, {
                    productCode: data.productCode,
                    searchString: data.searchString,
                });
                console.log(data.productCode);
                console.log(data.searchString);
                console.log(apiUrl);
                const response = yield fetch(apiUrl, {
                    method: "GET",
                    headers,
                });
                if (!response.ok) {
                    const error = yield response.json();
                    throw new Error(error.message || "Placement Search API call failed");
                }
                const result = yield response.json();
                return result;
            }
            catch (error) {
                DebugService.error("Placement Search API request failed");
                throw error;
            }
        });
    }
}
export default PlacementApiSearchService.getInstance();
